<main>
    <div>
        <h1>Privacy policy</h1>
        <p>As of: January 4, 2024</p><h2>Overview of contents</h2>
        <ul class="index">
            <li>
                <a class="index-link" href="#m3">Responsible</a>
            </li>
            <li>
                <a class="index-link" href="#mOverview">Overview of
                    processing</a>
            </li>
            <li>
                <a class="index-link" href="#m2427">Relevant Legal bases</a>
            </li>
            <li>
                <a class="index-link" href="#m27">Security measures</a>
            </li>
            <li>
                <a class="index-link" href="#m10">Rights of the data
                    subjects</a>
            </li>
            <li>
                <a class="index-link" href="#m225">Provision of Online Services
                    and Web Hosting</a>
            </li>
            <li>
                <a class="index-link" href="#m182">Contact and Inquiry
                    Management</a>
            </li>
            <li>
                <a class="index-link" href="#m136">Presence in social networks
                    (social media)</a>
            </li>
            <li>
                <a class="index-link" href="#m328">Plugins and Embedded
                    Functions as well as Content</a>
            </li>
            <li>
                <a class="index-link" href="#m15">Changes and Updates to the
                    Privacy Policy</a>
            </li>
        </ul>
        <h2 id="m3">Responsible</h2>
        <p>Nils Boelingen<br>
            Nordhäuser Str. 4<br>
            38723 Seesen</p>
        E-mail address: kontakt&#64;nils-boelingen.de

        <h2 id="mOverview">Overview of processing</h2>
        <p>The following overview summarizes the types of data processed and the
            purposes processed and the purposes of their processing and refers
            to the data subjects.</p>
        <h3>Types of data processed</h3>
        <ul>
            <li>Contact details.</li>
            <li>Content data.</li>
            <li>Usage data.</li>
            <li>Meta, communication and process data.</li>
        </ul>
        <h3>Categories of affected persons</h3>
        <ul>
            <li>Communication partner.</li>
            <li>Users.</li>
        </ul>
        <h3>Purposes of the processing</h3>
        <ul>
            <li>Contact requests and communication.</li>
            <li>Security measures.</li>
            <li>Managing and responding to inquiries.</li>
            <li>Feedback.</li>
            <li>Marketing.</li>
            <li>Provision of our online offer and user friendliness.</li>
            <li>Information technology infrastructure.</li>
        </ul>
        <h2 id="m2427">Relevant Legal bases</h2>
        <p><strong>Relevant legal bases according to the GDPR:</strong>
            Below you will find an overview of the legal bases of the GDPR on
            the basis of which we process personal data. Please note that, in
            addition to the provisions of the GDPR, national data protection
            data protection regulations may apply in your or our country of
            residence or domicile. may apply. Furthermore, should more specific
            legal bases apply in individual cases be applicable in individual
            cases, we will inform you of these in the privacy policy.</p>
        <ul>
            <li>
                <strong>Contract fulfillment and pre-contractual inquiries (Art.
                    6 para. 1 sentence 1 lit. b) GDPR)</strong>
                - Processing is necessary for the performance of a contract to
                which the data to which the data subject is party or in order to
                take steps at the pre-contractual measures which are carried out
                at the request of the data subject.
            </li>
            <li>
                <strong>Legitimate interests (Art. 6 para. 1 sentence 1 lit. f)
                    GDPR)</strong>
                - Processing is necessary for the purposes of the legitimate
                interests pursued of the controller or of a third party,
                provided that the interests or fundamental rights and freedoms
                of the data data subject which require the protection of
                personal data require the protection of personal data.
            </li>
        </ul>
        <p><strong>National data protection regulations in Germany: </strong>
            In addition to the data protection regulations of the GDPR national
            data protection regulations apply in Germany. These includes in
            particular the law on the protection against misuse of personal data
            in data processing (Federal Data Protection Act - BDSG). The BDSG
            contains in particular special regulations on the right to
            information, the right to deletion, the right to object, the
            processing of special categories of categories categories of
            personal data, processing for other purposes and the right to
            transmission and automated decision-making in individual cases.
            individual cases including profiling. Furthermore, the data
            protection laws of the individual federal states may apply.</p>
        <p><strong>Reference to validity of GDPR and Swiss DPA: </strong>
            This data protection notice serves to provide information in
            accordance with both the Swiss Federal Act on Data Protection (FADP)
            and the General Data Protection Regulation (GDPR). For this reason,
            please note that the terms of the GDPR are used due to the broader
            geographical application and comprehensibility. In particular,
            instead of the terms "processing" of "personal data",
            "overriding interest" and "particularly sensitive personal data"
            used in the Swiss DPA, the terms "processing" of "personal data",
            "legitimate interest" and "special categories of data" used in the
            GDPR are used. However, the legal meaning of the terms will continue
            to be used within the scope of the Swiss DPA. continues according to
            the Swiss DPA.</p>

        <h2 id="m27">Security measures</h2>
        <p>In accordance with the legal requirements, taking into account the
            state of the art, the implementation costs and the type, scope,
            circumstances and the purposes of the processing and the various
            probabilities of occurrence and the extent of the threat to the
            rights and freedoms of natural persons, appropriate of natural
            persons, appropriate technical and organizational measures to
            appropriate level of protection appropriate to the risk.</p>
        <p>The measures include, in particular, safeguarding confidentiality,
            integrity and availability of data by controlling the physical and
            electronic access to the data as well as the access to the data
            access, input, disclosure, ensuring availability and their
            separation. Furthermore, we have set up procedures that enable the
            exercise of data subject rights, the deletion of data and reactions
            to the endangerment of data. Furthermore we the protection of
            personal data as early as the development and selection of hardware,
            software and processes in accordance with the principle of data
            protection, through technology design and through data
            protection-friendly default settings.</p>
        <p>TLS/SSL encryption (https): To protect the data of users who access
            our online services, we use TLS/SSL encryption. TLS/SSL encryption.
            Secure Sockets Layer (SSL) is the standard technology for securing
            internet connections by encrypting the data transmitted between a
            website or app and a browser (or between two servers). Transport
            Layer Security (TLS) is an updated and more secure version of SSL.
            Hyper Text Transfer Protocol Secure (HTTPS) is displayed in the URL
            when a website is accessed secured by secured by an SSL/TLS
            certificate.</p>

        <h2 id="m10">Rights of the data subjects</h2>
        <p>Rights of the data subjects persons under the GDPR: As a data
            subject, you have the following rights under the GDPR various
            rights, which arise in particular from Art. 15 to 21 GDPR arise:</p>
        <ul>
            <li>
                <strong>Right to object: You have the right for reasons arising
                    from your particular situation, at any time against the
                    processing of personal data concerning you personal data
                    concerning you, which is based on Art. 6 para. 1 lit. e or f
                    GDPR, GDPR; this also applies to profiling based on these
                    profiling based on these provisions. If the data personal
                    data processed for the purpose of direct marketing operate,
                    you have the right to object at any time to the processing
                    personal data concerning you for the purpose of
                    such advertising; this also applies to profiling to the
                    extent that it with in connection with such direct is
                    connected.</strong>
            </li>
            <li>
                <strong>Right of revocation for consents:</strong>
                You have the right to withdraw your consents at any time
                revoked.
            </li>
            <li>
                <strong>Right to information:</strong>
                You have the right to obtain confirmation as to whether or not
                personal data processed and to information about this data as
                well as to further information and a copy of the data in
                accordance with the requirements.
            </li>
            <li>
                <strong>Right to rectification:</strong>
                You have in accordance with the legal requirements, the right to
                completion data concerning you or the rectification of data
                concerning you incorrect incorrect data concerning you.
            </li>
            <li>
                <strong> Right to deletion and restriction of
                    processing:</strong> Sie haben nach
                In accordance with the legal requirements, you have the right to
                demand that data concerning you be deleted immediately or,
                alternatively, to demand that the processing of the data be
                restricted in accordance with the legal requirements. to demand
                restriction of processing.
            </li>
            <li>
                <strong>Right to data portability:</strong>
                You have the right to access data concerning you that you have
                provided to us in accordance with the legal requirements in a
                structured structured, commonly used and machine-readable format
                or to have it transmission to another controller. request their
                transmission to another controller.
            </li>
            <li>
                <strong>Complaint to Supervisory authority:</strong>
                Without prejudice to any other administrative or judicial
                remedy, you have the right to lodge a complaint with a
                supervisory authority, in particular in the Member State of your
                habitual residence, place of work or place of the alleged
                infringement if you consider that the processing of personal
                data relating to you infringes this right. you personal data
                concerning you infringes the provisions of the GDPR violates.
            </li>
        </ul>

        <h2 id="m225">Provision of Online Services and Web Hosting</h2>
        <p>We process user data to provide them with our online services. For
            this purpose, we process the user's IP address, which is necessary
            to transmit the content and features of our online services to the
            user's browser or device.</p>
        <ul class="m-elements">
            <li>
                <strong>Processed Data Types:</strong> User data (e.g., visited
                websites, interest in content, access times); Meta,
                communication, and procedural data (e.g., IP addresses,
                timestamps, identification numbers, consent status); Content
                data (e.g., entries in online forms).
            </li>
            <li>
                <strong>Affected Individuals:</strong> Users (e.g., website
                visitors, users of online services).
            </li>
            <li>
                <strong>Purposes of Processing:</strong> Provision of our online
                services and user-friendliness; Information technology
                infrastructure (operation and provision of information systems
                and technical devices such as computers, servers, etc.);
                Security measures.
            </li>
            <li>
                <strong>Legal Basis:</strong> Legitimate interests (Art. 6(1)(f)
                GDPR).
            </li>
        </ul>
        <p><strong>Additional information about processing procedures, methods,
                and services:</strong></p>
        <ul class="m-elements">
            <li>
                <strong>Provision of Online Offer on Rented Storage
                    Space:</strong> For the provision of our online services, we
                use storage space, computing capacity, and software obtained
                from a corresponding server provider (also referred to as
                "web hoster"); <span class><strong>Legal Basis:</strong>
                    Legitimate interests (Art. 6(1)(f) GDPR).</span>
            </li>
            <li>
                <strong>Collection of Access Data and Logfiles:</strong> Access
                to our online offering is logged in the form of so-called
                "server log files." Server log files may include the address and
                name of the accessed websites and files, date and time of
                access, transferred data volumes, message about successful
                retrieval, browser type and version, user's operating system,
                referrer URL (the previously visited page), and usually IP
                addresses and the requesting provider. Server log files can be
                used for security purposes, such as avoiding server overload
                (especially in the case of abusive attacks, so-called DDoS
                attacks), and ensuring the load and stability of servers; <span
                    class><strong>Legal Basis:</strong> Legitimate interests
                    (Art. 6(1)(f) GDPR).</span> <strong>Data Deletion:</strong>
                Logfile information is stored for a maximum of 30 days and then
                deleted or anonymized. Data whose further storage is necessary
                for evidentiary purposes is exempt from deletion until the final
                clarification of the respective incident.
            </li>
            <li>
                <strong>Email Sending and Hosting:</strong> The web hosting
                services we use also include the sending, receiving, and storage
                of emails. For these purposes, the addresses of recipients and
                senders, as well as additional information regarding email
                transmission (e.g., the involved providers) and the contents of
                the respective emails, are processed. The aforementioned data
                may also be processed for the purpose of detecting SPAM. Please
                note that emails on the internet are generally not encrypted.
                While emails are typically encrypted in transit, they are not
                encrypted on the servers from which they are sent and received
                unless end-to-end encryption is used. Therefore, we cannot
                assume responsibility for the transmission of emails between the
                sender and reception on our server; <span class><strong>Legal
                        Basis:</strong> Legitimate interests (Art. 6(1)(f)
                    GDPR).</span>
            </li>
            <li>
                <strong>ALL-INKL:</strong> Services in the field of providing
                information technology infrastructure and related services
                (e.g., storage space and/or computing capacities);
                <strong>Service Provider:</strong> ALL-INKL.COM - Neue Medien
                Münnich, Owner: René Münnich, Hauptstraße 68, 02742
                Friedersdorf, Germany; <span class><strong>Legal Basis:</strong>
                    Legitimate interests (Art. 6(1)(f) GDPR).</span>
                <strong>Website:</strong> <a href="https://all-inkl.com/"
                    target="_blank">https://all-inkl.com/</a>; <strong>Privacy
                    Policy:</strong> <a
                    href="https://all-inkl.com/datenschutzinformationen/"
                    target="_blank">https://all-inkl.com/datenschutzinformationen/</a>.
                <strong>Data Processing Agreement:</strong> Provided by the
                service provider.
            </li>
        </ul>
        <h2 id="m182">Contact and Inquiry Management</h2>
        <p>When contacting us (e.g., by mail, contact form, email, phone, or via
            social media) and within existing user and business relationships,
            the information of the inquiring individuals is processed as far as
            necessary to respond to contact inquiries and any requested
            measures.</p>
        <ul class="m-elements">
            <li>
                <strong>Processed Data Types:</strong> Contact data (e.g.,
                email, phone numbers); Content data (e.g., entries in online
                forms); User data (e.g., visited websites, interest in content,
                access times); Meta, communication, and procedural data (e.g.,
                IP addresses, timestamps, identification numbers, consent
                status).
            </li>
            <li>
                <strong>Affected Individuals:</strong> Communication partners.
            </li>
            <li>
                <strong>Purposes of Processing:</strong> Contact inquiries and
                communication; Management and response to inquiries; Feedback
                (e.g., collecting feedback via online form). Provision of our
                online services and user-friendliness.
            </li>
            <li class>
                <strong>Legal Basis:</strong> Legitimate interests (Art. 6(1)(f)
                GDPR). Contract fulfillment and pre-contractual inquiries (Art.
                6(1)(b) GDPR).
            </li>
        </ul>
        <p><strong>Additional information about processing procedures, methods,
                and services:</strong></p>
        <ul class="m-elements">
            <li>
                <strong>Contact Form:</strong> When users contact us via our
                contact form, email, or other communication channels, we process
                the data provided to us in this context to handle the stated
                request; <span class><strong>Legal Basis:</strong> Contract
                    fulfillment and pre-contractual inquiries (Art. 6(1)(b)
                    GDPR), Legitimate interests (Art. 6(1)(f) GDPR).</span>
            </li>
        </ul>
        <h2 id="m136">Presences on Social Networks (Social Media)</h2>
        <p>We maintain online presences within social networks and process user
            data in this context to communicate with active users or to provide
            information about us.</p>
        <p>We note that user data may be processed outside the European Union.
            This may pose risks for users because, for example, the enforcement
            of users' rights could be more difficult.</p>
        <p>Furthermore, user data within social networks is usually processed
            for market research and advertising purposes. For example, user
            profiles can be created based on usage behavior and resulting user
            interests. These user profiles can then be used to display
            advertisements within and outside the networks that presumably match
            the users' interests. For these purposes, cookies are usually stored
            on users' computers, containing information about users' usage
            behavior and interests. Additionally, data can be stored in user
            profiles independently of the devices used by users (especially if
            users are members of the respective platforms and are logged
            in).</p>
        <p>For a detailed presentation of the respective processing methods and
            opt-out options, we refer to the privacy policies and information
            provided by the operators of the respective networks.</p>
        <p>Even in the case of requests for information and the exercise of data
            subject rights, we point out that these can be most effectively
            asserted with the providers. Only the providers have access to the
            users' data and can directly take appropriate measures and provide
            information. If you still need assistance, you can contact us.</p>
        <ul class="m-elements">
            <li>
                <strong>Processed Data Types:</strong> Contact data (e.g.,
                email, phone numbers); Content data (e.g., entries in online
                forms); User data (e.g., visited websites, interest in content,
                access times); Meta, communication, and procedural data (e.g.,
                IP addresses, timestamps, identification numbers, consent
                status).
            </li>
            <li>
                <strong>Affected Individuals:</strong> Users (e.g., website
                visitors, users of online services).
            </li>
            <li>
                <strong>Purposes of Processing:</strong> Contact inquiries and
                communication; Feedback (e.g., collecting feedback via online
                form). Marketing.
            </li>
            <li class><strong>Legal Basis:</strong> Legitimate interests (Art.
                6(1)(f) GDPR).</li>
        </ul>
        <p><strong>Additional information about processing procedures, methods,
                and services:</strong></p>
        <ul class="m-elements">
            <li>
                <strong>LinkedIn:</strong> Social network; <strong>Service
                    Provider:</strong> LinkedIn Ireland Unlimited Company,
                Wilton Place, Dublin 2, Ireland; <span class><strong>Legal
                        Basis:</strong> Legitimate interests (Art. 6(1)(f)
                    GDPR).</span> <strong>Website:</strong> <a
                    href="https://www.linkedin.com"
                    target="_blank">https://www.linkedin.com</a>;
                <strong>Privacy Policy:</strong> <a
                    href="https://www.linkedin.com/legal/privacy-policy"
                    target="_blank">https://www.linkedin.com/legal/privacy-policy</a>;
                <strong>Basis for Third-Country Transfer:</strong> <span
                    class>EU-US Data Privacy Framework (DPF),</span> Standard
                Contractual Clauses (<a href="https://legal.linkedin.com/dpa"
                    target="_blank">https://legal.linkedin.com/dpa</a>);
                <strong>Opt-Out Options:</strong> <a
                    href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
                    target="_blank">https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out</a>;
                <strong>Additional Information:</strong> We, together with
                LinkedIn Ireland Unlimited Company, are responsible for the
                collection (but not further processing) of visitor data for the
                purpose of creating "Page Insights" (statistics) of our LinkedIn
                profiles. This data includes information about the types of
                content users view or interact with, or actions they take, as
                well as information about the devices used by users (e.g., IP
                addresses, operating system, browser type, language settings,
                cookie data) and information from users' profiles, such as job
                function, country, industry, hierarchy level, company size, and
                employment status. Privacy information regarding the processing
                of user data by LinkedIn can be found in LinkedIn's privacy
                policy: <a href="https://www.linkedin.com/legal/privacy-policy"
                    target="_blank">https://www.linkedin.com/legal/privacy-policy</a>.
                We have entered into a special agreement with LinkedIn Ireland
                ("Page Insights Joint Controller Addendum (the 'Addendum')," <a
                    href="https://legal.linkedin.com/pages-joint-controller-addendum"
                    target="_blank">https://legal.linkedin.com/pages-joint-controller-addendum</a>),
                which regulates, among other things, the security measures
                LinkedIn must adhere to and in which LinkedIn has agreed to
                fulfill data subject rights (i.e., users can address requests
                for information or deletion directly to LinkedIn). The rights of
                users (especially regarding information, deletion, objection,
                and complaint to the competent supervisory authority) are not
                restricted by the agreements with LinkedIn. Joint responsibility
                is limited to the collection of data by and transmission to the
                Ireland Unlimited Company, an EU-based company. The further
                processing of data is the sole responsibility of the Ireland
                Unlimited Company, particularly concerning the transfer of data
                to the parent company LinkedIn Corporation in the USA.</li>
        </ul>
        <h2 id="m328">Plugins and Embedded Functions as well as Content</h2>
        <p>We integrate functional and content elements into our online
            offering, which are obtained from the servers of their respective
            providers (hereinafter referred to as "third-party providers"). This
            may include graphics, videos, or maps (hereinafter collectively
            referred to as "content").</p>
        <p>The integration always requires that the third-party providers of
            this content process the IP address of the users, as they could not
            send the content to their browser without the IP address. The IP
            address is thus necessary for the presentation of these contents or
            functions. We strive to only use content whose respective providers
            use the IP address solely for the delivery of the content.
            Third-party providers may also use so-called pixel tags (invisible
            graphics, also known as "web beacons") for statistical or marketing
            purposes. Through the "pixel tags," information such as visitor
            traffic on the pages of this website can be evaluated. The
            pseudonymous information may also be stored in cookies on users'
            devices and may include technical information about the browser and
            operating system, referring websites, visit time, as well as other
            information about the use of our online offering, and may also be
            combined with such information from other sources.</p>
        <ul class="m-elements">
            <li>
                <strong>Processed Data Types:</strong> User data (e.g., visited
                websites, interest in content, access times); Meta,
                communication, and procedural data (e.g., IP addresses,
                timestamps, identification numbers, consent status).
            </li>
            <li>
                <strong>Affected Individuals:</strong> Users (e.g., website
                visitors, users of online services).
            </li>
            <li>
                <strong>Purposes of Processing:</strong> Provision of our online
                offering and user-friendliness.
            </li>
            <li class>
                <strong>Legal Basis:</strong> Legitimate interests (Art. 6(1)(f)
                GDPR).
            </li>
        </ul>
        <p><strong>Additional information about processing procedures, methods,
                and services:</strong></p>
        <ul class="m-elements">
            <li>
                <strong>Integration of third-party software, scripts, or
                    frameworks (e.g., jQuery): </strong>We integrate software
                into our online offering that we retrieve from servers of other
                providers (e.g., function libraries that we use for the
                presentation or user-friendliness of our online offering). In
                this process, the respective providers collect the IP address of
                users and may process it for the purpose of transmitting the
                software to users' browsers, as well as for security purposes,
                evaluation, and optimization of their offering. - We integrate
                software into our online offering that we retrieve from servers
                of other providers (e.g., function libraries that we use for the
                presentation or user-friendliness of our online offering). In
                this process, the respective providers collect the IP address of
                users and may process it for the purpose of transmitting the
                software to users' browsers, as well as for security purposes,
                evaluation, and optimization of their offering; <span
                    class><strong>Legal Basis:</strong> Legitimate interests
                    (Art. 6(1)(f) GDPR).</span>
            </li>
            <li>
                <strong>Google Fonts (Hosting on our own server):
                </strong>Provision of font files for user-friendly presentation
                of our online offering; <strong>Service Provider:</strong>
                Google Fonts are hosted on our server, no data is transmitted to
                Google; <span class><strong>Legal Basis:</strong> Legitimate
                    interests (Art. 6(1)(f) GDPR).</span>
            </li>
        </ul>
        <h2 id="m15">Changes and Updates to the Privacy Policy</h2>
        <p>We ask you to regularly check the content of our privacy policy. We
            adjust the privacy policy as soon as changes to the data processing
            we carry out require it. We will inform you as soon as changes
            necessitate your cooperation (e.g., consent) or any other individual
            notification.</p>
        <p>If we provide addresses and contact information of companies and
            organizations in this privacy policy, please note that addresses may
            change over time, and we ask you to verify the information before
            contacting them.</p>
        <p class="seal"><a href="https://datenschutz-generator.de/"
                title="Legal text by Dr. Schwenke - click for more information."
                target="_blank" rel="noopener noreferrer nofollow">Created with
                the free privacy policy generator by Dr. Thomas Schwenke</a></p>
    </div>
    <img src="assets/img/privacy_policy/red_shadow_1.png" class="shadow-1">
    <img src="assets/img/privacy_policy/orange_shadow_1.png" class="shadow-2">
    <img src="assets/img/privacy_policy/red_shadow_2.png" class="shadow-3">
    <img src="assets/img/privacy_policy/orange_shadow_2.png" class="shadow-4">
</main>